import { ColorX } from 'framework/components/color/ColorX';
import { LoanProcessStatus } from 'gen/ApiClient';

export const LoanProcessStatusToColorXRecord: Record<LoanProcessStatus, ColorX> = {
	Cancelled: 'error',
	Started: 'success',
	Ended: 'default',
};
